import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import BigCalendar from 'react-big-calendar'
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from './store/actions';
import { Grid, IconButton, Icon, Typography, TextField, Button, CardContent, Card, CardHeader, AppBar, Toolbar, Tooltip } from '@material-ui/core';
import { DragDropContext } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import { withRouter } from 'react-router-dom';
import DraggableCourse from './CompanyCalendar/DraggableCourse';
import OverwriteDialog from './CompanyCalendar/OverwriteDialog';
import BreakLessonFromCourseDialog from './CompanyCalendar/BreakLessonFromCourseDialog';
import AddLessonsToExistingCourse from './CompanyCalendar/AddLessonsToCourseDialog';
import DeleteItemDialog from './CompanyCalendar/DeleteItemDialog';

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

const DragAndDropCalendar = withDragAndDrop(BigCalendar, { backend: false });

// let allViews = Object.keys(BigCalendar.Views).map(k => BigCalendar.Views[k]);
const allViews = ["month", "day"]

const styles = theme => ({
    root: {
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        flex: 1,
        '& .rbc-header': {
            padding: '12px 6px',
            fontWeight: 500,
            fontSize: 14
        },
        '& .rbc-label': {
            padding: '8px 6px'
        },
        '& .rbc-today': {
            backgroundColor: 'transparent'
        },
        '& .rbc-header.rbc-today, & .rbc-month-view .rbc-day-bg.rbc-today': {
            borderBottom: '2px solid ' + theme.palette.secondary.main + '!important'
        },
        '& .rbc-month-view, & .rbc-time-view, & .rbc-agenda-view': {
            padding: 24,
            ...theme.mixins.border(0)
        },
        '& .rbc-agenda-view table': {
            ...theme.mixins.border(1),
            '& thead > tr > th': {
                ...theme.mixins.borderBottom(0)
            },
            '& tbody > tr > td': {
                padding: '12px 6px',
                '& + td': {
                    ...theme.mixins.borderLeft(1)
                }
            }
        },
        '& .rbc-time-view': {
            '& .rbc-time-header': {
                // ...theme.mixins.border(1)
                display: 'none'
            },
            '& .rbc-time-content': {
                flex: '0 1 auto',
                ...theme.mixins.border(1)
            }
        },
        '& .rbc-month-view': {
            '& > .rbc-row': {
                ...theme.mixins.border(1)
            },
            '& .rbc-month-row': {
                ...theme.mixins.border(1),
                borderWidth: '0 1px 1px 1px!important',
                minHeight: 128
            },
            '& .rbc-header + .rbc-header': {
                ...theme.mixins.borderLeft(1)
            },
            '& .rbc-header': {
                ...theme.mixins.borderBottom(0)
            },
            '& .rbc-day-bg + .rbc-day-bg': {
                ...theme.mixins.borderLeft(1)
            }
        },
        '& .rbc-day-slot .rbc-time-slot': {
            ...theme.mixins.borderTop(1),
            opacity: 0.5
        },
        '& .rbc-time-header > .rbc-row > * + *': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-time-content > * + * > *': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-day-bg + .rbc-day-bg': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-time-header > .rbc-row:first-child': {
            ...theme.mixins.borderBottom(1)
        },
        '& .rbc-timeslot-group': {
            minHeight: 64,
            ...theme.mixins.borderBottom(1)
        },
        '& .rbc-date-cell': {
            padding: 8,
            fontSize: 16,
            fontWeight: 400,
            opacity: .5,
            '& > a': {
                color: 'inherit'
            }
        },
        '& .rbc-event': {
            borderRadius: 0,
            padding: '4px 8px',
            border: '2px solid black',
            backgroundColor: theme.palette.primary.dark,
            color: theme.palette.primary.contrastText,
            boxShadow: theme.shadows[0],
            transitionProperty: 'box-shadow',
            transitionDuration: theme.transitions.duration.short,
            transitionTimingFunction: theme.transitions.easing.easeInOut,
            position: 'relative',
            '&:hover': {
                border: '2px solid #303030',
                boxShadow: theme.shadows[2]
            }
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resize-ew-anchor': {
            display: 'none'
        },
        '& .rbc-event-label': {
            display: 'none'
        },
        '& .rbc-row-segment': {
            padding: '0 4px 4px 4px'
        },
        '& .rbc-off-range-bg': {
            backgroundColor: theme.palette.type === 'light' ? 'rgba(0,0,0,0.03)' : 'rgba(0,0,0,0.16)'
        },
        '& .rbc-show-more': {
            color: theme.palette.secondary.main,
            background: 'transparent'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event': {
            position: 'static'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:first-child': {
            left: 0,
            top: 0,
            bottom: 0,
            height: 'auto'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:last-child': {
            right: 0,
            top: 0,
            bottom: 0,
            height: 'auto'
        }
    },
    addButton: {
        display: 'none'
    },
});

class CompanySchedule extends Component {

    state = {
        currentView: 'month',
        date: new Date(),
        overwriteDialog: false,
        oldOverwrite: {},
        newOverwrite: {},
        overwriteDate: '',
        activeDraggableList: 'Courses',
        seachText: '',
        breakLessonFromComponentDialog: false,
        moveLessonInfo: {},
        addToCourse: {
            dialog: false,
            event: {}
        },
        deleteItemDialog: {
            dialog: false,
            event: {}
        },
        hover_id: 0
    }

    handleSearchChange = (e) => {
        this.setState({ searchText: e.target.value })
    }

    leftComponentMenuDrop = (event, start, end) => {
        switch (event.eventType) {
            case ('fullCourse'):
                {
                    this.props.addCourseToSchedule(event.id, this.props.company.company_id, start)
                    return null
                }
            case ('fullModule'):
                {
                    this.setState({
                        addToCourse: {
                            dialog: true,
                            event: event,
                            start: start,
                        }
                    })
                    return null
                }
            case ('fullLesson'):
                {
                    this.setState({
                        addToCourse: {
                            dialog: true,
                            event: event,
                            start: start,
                        }
                    })
                    return null
                }
            default:
                {
                    return null
                }
        }
    }

    existingEventDrop = (event, start, end) => {
        if (moment(event.start).format('YYYY-MM-DD') === moment(start).format('YYYY-MM-DD')) {
            return null;
        }

        if (moment(start).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
            return null;
        }

        let overwrittenLesson = this.props.events.filter(e => moment(e.start).format('YYYY-MM-DD') === moment(start).format('YYYY-MM-DD'))
        if (overwrittenLesson.length > 0) {
            this.setState({ overwriteDialog: true, newOverwrite: event, oldOverwrite: overwrittenLesson[0], overwriteDate: moment(start).format('YYYY-MM-DD') })
        } else {
            // Old version of drop allowing for orphaning of lessons
            // if (event.company_calendar_course_id != 0 || event.company_calendar_module_id != 0) {
            // this.setState({ breakLessonFromComponentDialog: true, moveLessonInfo: { event: event, start: start } })
            // }
            // else {
            this.props.moveLesson(event, start, this.props.company.company_id, false)
            // }
        }
    }

    dayEventChange = (event, start, end) => {
        this.props.resizeDayEvent({ event: event, start, end }, this.props.company.company_id)
    }

    moveEvent = ({ event, start, end }) => {
        if (event.eventType.startsWith('full')) {
            return this.leftComponentMenuDrop(event, start, end)
        }
        else if (event.eventType.startsWith('existing')) {
            return this.existingEventDrop(event, start, end)
        } else {
            this.dayEventChange(event, start, end)
        }
    }

    resizeEvent = (resizeType, { event, start, end }) => {
        this.props.resizeDayEvent({
            event,
            start,
            end,
        }, this.props.company.company_id);
    };

    onNavigate = (event) => {
        const beginningMonth = this.state.date.getMonth()
        this.setState({ date: event })
        if (event.getMonth() === beginningMonth) {
            this.props.getDayEvents(this.props.company.company_id,
                moment(new Date(event)).format('YYYY-MM-DD'))
        }
        else {
            // this.props.getEvents(this.props.company.company_id, event.getMonth(), event.getFullYear())
            this.props.getEvents(this.props.company.company_id, event)
            this.props.getScheduledCourses(this.props.company.company_id, event)
            this.props.getDayEvents(this.props.company.company_id, moment(new Date(event)).format('YYYY-MM-DD'))
        }
    }

    selectSlot = (slotInfo) => {
        this.props.getDayEvents(this.props.company.company_id, moment(new Date(slotInfo.start)).format('YYYY-MM-DD'))
        this.setState({ date: slotInfo.start, currentView: 'day' })
    }

    onView = (view) => {
        this.state.currentView === 'month' ? this.setState({ currentView: 'day' }) : this.setState({ currentView: 'month' })
        this.props.getDayEvents(this.props.company.company_id, moment(new Date(this.state.date)).format('YYYY-MM-DD'))
    }

    /** new lesson is the one being dragged, old is the one that is already on that day
    * actionType can be- replace: will hit API to put new lesson on spot and delete old one. swap: hit api and change both dates, goBack: close the dialog and change nothing
    */
    closeOverwiteDialog = (actionType, newLesson, oldLesson, moveDate) => {
        this.setState({ overwriteDialog: false })
        if (actionType === 'goBack') {
            return null
        }
        if (actionType === 'drop') {
            /** check if dragging from calendar or left menu */
            if (newLesson.eventType.startsWith('full')) {
                this.props.addLessonToSchedule(newLesson.id, this.props.company.company_id, moment(moveDate), 0)
            }
            else {
                this.props.moveLesson(newLesson, moveDate, this.props.company.company_id, false)
            }

        }
        else {
            this.props.overwriteLesson(this.props.company.company_id, actionType, newLesson, oldLesson)
        }
    }

    closeMoveDialog = (lesson, breakBool) => {
        this.setState({ breakLessonFromComponentDialog: false })
        this.props.moveLesson(lesson.event, lesson.start, this.props.company.company_id, breakBool)
    }

    closeLessonModuleDrop = (event, addBool, start, company_course_id, clickAway) => {
        this.setState({ addToCourse: { dialog: false, event: {} } })
        if (clickAway) {
            return true
        }
        if (addBool) {
            if (event.eventType === 'fullModule') {
                return this.props.addModuleToSchedule(event.id, this.props.company.company_id, start, company_course_id)
            }
            return this.props.addLessonToSchedule(event.id, this.props.company.company_id, start, company_course_id)
        }
        if (event.eventType === 'fullModule') {
            return this.props.addModuleToSchedule(event.id, this.props.company.company_id, start, 0)
        }
        return this.props.addLessonToSchedule(event.id, this.props.company.company_id, start, 0)
    }

    eventStyleGetter = (event, start, end, isSelected) => {
        switch (event.eventType) {
            case ('existingEventCourse'): {
                let style = { backgroundColor: event.selected ? 'green' : event.color, color: this.props.theme.palette.getContrastText(event.color) }
                return { style: style }
            }
            case ('existingEventModule'): {
                let style = { backgroundColor: event.selected ? '#B10DC9' : '#0074D9' }
                return { style: style }
            }
            case ('existingEventLesson'): {
                let style = { backgroundColor: event.selected ? '#01FF70' : '#FF851B' }
                return { style: style }
            }
            case ('dayEventQuiz'): {
                let style = { backgroundColor: event.selected ? '#001f3f' : '#FF851B' }
                return { style: style }
            }
            case ('dayEventAssignment'): {
                let style = { backgroundColor: event.selected ? '#85144b' : event.Color }
                return { style: style }
            }
            default: {
                let style = { backgroundColor: event.selected ? 'green' : '' }
                return { style: style }
            }
        }
    }

    openDeleteComponentDialog = (event) => {
        if (event.eventType != "existingEventLesson") {
            this.setState({ deleteItemDialog: { dialog: true, event: event } })
        }
        else {
            this.deleteComponentFromSchedule(event)
        }
    }

    deleteComponentFromSchedule = (event) => {
        switch (event.eventType) {
            case ('existingEventCourse'): {
                this.props.deleteCourseFromSchedule(this.props.company.company_id, event.company_calendar_course_id, event)
                return null
            }
            case ('existingEventModule'): {
                this.props.deleteModuleFromSchedule(this.props.company.company_id, event.company_calendar_module_id, event)
                return null
            }
            case ('existingEventLesson'): {
                this.props.deleteLessonFromSchedule(this.props.company.company_id, event.company_calendar_day_id, event)
                return null
            }
            default: {
                return null
            }
        }
    }

    handleDeleteDialogClose = (fullDelete, event, clickAway) => {
        this.setState({ deleteItemDialog: { dialog: false, event: {} } })
        if (clickAway) {
            return true
        }
        if (fullDelete) {
            this.deleteComponentFromSchedule(event)
        }
        else {
            this.props.deleteLessonFromSchedule(this.props.company.company_id, event.company_calendar_day_id, event)
        }
    }

    render() {
        const { classes, events, allCourses, allModules, allLessons, dayEvents } = this.props
        console.log(events)

        const testComponent = ({ event }) => {
            let delete_button = <Tooltip 
                                    style={{ display: this.state.hover_id === event.id ? 'flex' : 'none' }} 
                                    title="Student data related to course"
                                    placement={'top-start'}    
                                >
                                    <Icon>lock</Icon>
                                </Tooltip>

            if (moment(event.start) > moment() || event.studentCount === 0) {
                delete_button = (
                    <div style={{ display: this.state.hover_id === event.id ? 'flex' : 'none' }}>
                        <IconButton
                            style={{ width: '10px', height: '10px', marginTop: '-10px' }}
                            onClick={() => this.openDeleteComponentDialog(event)}
                        >
                            <Icon>delete</Icon>
                        </IconButton>
                    </div>
                )
            }

            return (
                <div
                    onMouseEnter={() => this.setState({ hover_id: event.id })}
                    onMouseLeave={() => this.setState({ hover_id: 0 })}
                >
                    {delete_button}
                    <div style={{ paddingTop: this.state.hover_id === event.id ? '10px' : '0px' }} >
                        <span style={{ fontSize: '12px' }} >{event.title} </span>

                        <br></br>
                        <span style={{ fontSize: '10px' }} >{event.courseName} </span>
                    </div>
                </div>
            )
        }


        const dayComponent = ({ event }) => {
            let delete_button = null;
            if (moment(event.start) > moment()) {
                delete_button = (
                    <IconButton
                        style={{ padding: '0px', margin: '0px' }}
                        onClick={() => this.props.deleteDayEvent(event.id, this.props.company.company_id, event.start)}
                    >
                        <Icon>delete</Icon>
                    </IconButton>
                );
            }

            return (
                <div>
                    <div className='float-left' style={{ paddingTop: '4px' }}>
                        {moment(event.start).format('h:mm A')} - {moment(event.end).format('h:mm A')}
                    </div>

                    <div className='float-right'>
                        {event.title}
                        {delete_button}
                    </div>

                </div>
            )
        }
        console.log(allCourses)
        const draggableCourses = allCourses
            .filter(course => course.Unscheduled === 0)
            .filter(course => !this.state.searchText || course.CourseName.toLowerCase().includes(this.state.searchText.toLowerCase()))
            .slice(0, 10)
            .map(course => {
                return (
                    <DraggableCourse
                        key={course.course_id}
                        event={{
                            modelName: course.CourseName,
                            id: course.course_id,
                            eventType: 'fullCourse',
                            allDay: true,
                            backgroundColor: course.Color,
                            textColor: this.props.theme.palette.getContrastText(course.Color)

                        }}
                        onExpand={this.props.getCoursePreview}
                        previewData={this.props.coursePreviewData.filter(c => c.course_id === course.course_id)}
                    />
                )
            })

        const draggableModules = allModules
            .filter(module => !this.state.searchText || module.ModuleName.toLowerCase().includes(this.state.searchText.toLowerCase()))
            .slice(0, 10)
            .map(module => {
                return (
                    <DraggableCourse
                        key={module.module_id}
                        event={{
                            modelName: module.ModuleName,
                            id: module.module_id,
                            eventType: 'fullModule',
                            allDay: true,
                            backgroundColor: '#0074D9'
                        }}
                        onExpand={this.props.getModulePreview}
                        previewData={this.props.modulePreviewData.filter(m => m.module_id === module.module_id)}
                    />
                )
            })

        const draggableLessons = allLessons
            .filter(lesson => lesson.Unscheduled === 0)
            .filter(lesson => !this.state.searchText || lesson.LessonName.toLowerCase().includes(this.state.searchText.toLowerCase()))
            .slice(0, 10)
            .map(lesson => {
                return (
                    <DraggableCourse
                        key={lesson.lesson_id}
                        event={{
                            modelName: lesson.LessonName,
                            id: lesson.lesson_id,
                            eventType: 'fullLesson',
                            allDay: true,
                            backgroundColor: '#FF851B',
                        }}
                    />
                )
            })

        const draggableItems = (prop) => {
            if (prop === 'Courses') {
                return draggableCourses
            }
            else if (prop === 'Modules') {
                return draggableModules
            }
            else {
                return draggableLessons
            }
        }
        return (
            <div className={classes.root}>
                <OverwriteDialog
                    open={this.state.overwriteDialog}
                    newLesson={this.state.newOverwrite}
                    oldLesson={this.state.oldOverwrite}
                    date={this.state.overwriteDate}
                    resolveOverwrite={this.props.resolveOverwrite}
                    closeDialogState={this.closeOverwiteDialog}
                    classes={this.props.classes}
                />

                <BreakLessonFromCourseDialog
                    open={this.state.breakLessonFromComponentDialog}
                    event={this.state.moveLessonInfo}
                    closeDialogState={this.closeMoveDialog}
                    classes={this.props.classes}
                />

                <AddLessonsToExistingCourse
                    open={this.state.addToCourse.dialog}
                    event={this.state.addToCourse.event}
                    start={this.state.addToCourse.start}
                    classes={this.props.classes}
                    closeDialogState={this.closeLessonModuleDrop}
                    courses={this.props.scheduledCourses}
                />

                <DeleteItemDialog
                    open={this.state.deleteItemDialog.dialog}
                    event={this.state.deleteItemDialog.event}
                    classes={this.props.classes}
                    closeDialogState={this.handleDeleteDialogClose}
                />

                <Grid container spacing={24}>
                    <Grid item xs={3}>
                        <AppBar position="static">
                            <Toolbar className={classes.eventCardContent}>
                                <IconButton
                                    onClick={() => this.setState({ activeDraggableList: this.state.activeDraggableList === 'Lessons' ? 'Modules' : 'Courses' })}
                                    disabled={this.state.activeDraggableList === 'Courses'}
                                    color="inherit"
                                >
                                    <Icon>chevron_left</Icon>
                                </IconButton>
                                <span style={{ fontSize: '20px' }} >{this.state.activeDraggableList}</span>
                                <IconButton
                                    onClick={() => this.setState({ activeDraggableList: this.state.activeDraggableList === 'Courses' ? 'Modules' : 'Lessons' })}
                                    disabled={this.state.activeDraggableList === 'Lessons'}
                                    color="inherit"
                                >
                                    <Icon>chevron_right</Icon>
                                </IconButton>
                            </Toolbar>
                        </AppBar>
                        <Card>
                            <CardContent>
                                <TextField
                                    id="search"
                                    label={<Icon>search</Icon>}
                                    className='searchText'
                                    value={this.state.searchText}
                                    onChange={(e) => this.handleSearchChange(e)}
                                    margin="normal"
                                    disabled={this.props.view_type === 'detail'}
                                />
                                {draggableItems(this.state.activeDraggableList)}
                            </CardContent>
                        </Card>
                        <Button variant={"outlined"} onClick={() => this.props.history.push('/builder/course')} color="primary">Build Course</Button>
                    </Grid>

                    <Grid item xs={9} >
                        <Card>
                            <CardContent>
                                <DragAndDropCalendar
                                    popup
                                    selectable={false}
                                    view={this.state.currentView}
                                    onEventDrop={this.props.view_type === 'edit' ? this.moveEvent : null}
                                    resizable
                                    onEventResize={this.resizeEvent}
                                    className="flex flex-1"
                                    events={this.state.currentView === 'month' ? events : dayEvents}
                                    views={allViews}
                                    showMultiDayTimes
                                    defaultDate={new Date(2018, 10, 1)}
                                    defaultView="month"
                                    onSelectSlot={(slotInfo) => this.selectSlot(slotInfo)}
                                    date={this.state.date}
                                    onNavigate={(event) => this.onNavigate(event)}
                                    eventPropGetter={(this.eventStyleGetter)}
                                    components={{ event: testComponent, day: { event: dayComponent } }}
                                    onView={(view) => this.onView(view)}
                                    min={new Date(moment().startOf('day').add(6, 'hours'))}
                                    max={new Date(moment().startOf('day').add(20, 'hours'))}
                                    step={30}
                                    onDoubleClickEvent={event => {
                                        if (event.company_calendar_course_id != 0) {
                                            this.props.history.push('/scheduled_course/edit/' + event.company_calendar_course_id)
                                        }
                                    }}
                                    draggableAccessor={(event) => moment(event.start) > moment()}
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCourseLessons: Actions.getCourseLessons,
        addCourseToSchedule: Actions.addCourseToSchedule,
        addModuleToSchedule: Actions.addModuleToSchedule,
        addLessonToSchedule: Actions.addLessonToSchedule,
        getCoursePreview: Actions.getCoursePreview,
        getModulePreview: Actions.getModulePreview,
        getEvents: Actions.getEvents,
        getDayEvents: Actions.getDayEvents,
        moveLesson: Actions.moveLesson,
        overwriteLesson: Actions.overwriteLesson,
        handleEventSelect: Actions.handleEventSelect,
        deleteCourseFromSchedule: Actions.deleteCourseFromSchedule,
        deleteModuleFromSchedule: Actions.deleteModuleFromSchedule,
        deleteLessonFromSchedule: Actions.deleteLessonFromSchedule,
        resizeDayEvent: Actions.resizeDayEvent,
        deleteDayEvent: Actions.deleteDayEvent,
        getScheduledCourses: Actions.getScheduledCourses
    }, dispatch);
}

function mapStateToProps({ companyApp }) {
    return {
        scheduledCourses: companyApp.companies.scheduledCourses
    }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(CompanySchedule)));


// WEBPACK FOOTER //
// src/main/content/company/CompanySchedule.js